
import { useState } from "react";
import  "./MouthfeelIntensity.css";


const Aging = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aging===0?0:data.aging);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="MouthfeelIntensityradiocard" name="aging" onChange={onChangeValue}>
    <div class="MouthfeelIntensityrating-container">
      
      <div class="MouthfeelIntensityrating">
        <form class="MouthfeelIntensityrating-form-1" >

        <label for={`AG1F-${count}`}>
        <input type="radio"  name="aging" class="aging1" id={`AG1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>
  
          <label for={`AG2F-${count}`}>
        <input type="radio" name="aging" class="aging2" id={`AG2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>
  
          <label for={`AG3F-${count}`}>
        <input type="radio" name="aging" class="aging3" id={`AG3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>
  
          <label for={`AG4F-${count}`}>
        <input type="radio" name="aging" class="aging4" id={`AG4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>
       
        </label>
  
          <label for={`AG5F-${count}`}>
        <input type="radio" name="aging" class="aging5" id={`AG5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>
  

    );
}

export default Aging;